import { useCallback, useEffect, useState } from 'react'

export type UseBonusPanelModalReturn = {
	isModalOpen: boolean
	openModal: () => void
	closeModal: () => void
	onAuthSuccess: () => void
	isAuthorizedSuccessfully: boolean
}

/**
 * Хук для управления состоянием модалки авторизации в BonusesPanel
 */
export const useBonusPanelModal = (isAuthorized?: boolean): UseBonusPanelModalReturn => {
	const [isModalOpen, setIsModalOpen] = useState(false)
	const [isAuthorizedSuccessfully, setIsAuthorizedSuccessfully] = useState(isAuthorized)

	// Синхронизируем внутреннее состояние с внешним пропсом
	useEffect(() => {
		setIsAuthorizedSuccessfully(isAuthorized)
	}, [isAuthorized])

	const openModal = useCallback(() => {
		setIsModalOpen(true)
	}, [])

	const closeModal = useCallback(() => {
		setIsModalOpen(false)
	}, [])

	const onAuthSuccess = useCallback(() => {
		setIsModalOpen(false)
		// Задержка для плавного закрытия модалки перед обновлением состояния
		setTimeout(() => {
			setIsAuthorizedSuccessfully(true)
		}, 1000)
	}, [])

	return {
		isModalOpen,
		openModal,
		closeModal,
		onAuthSuccess,
		isAuthorizedSuccessfully
	}
}
